<script setup lang="ts">
import getGpsTrackerSettingResponse from '@/types/responses/getGpsTrackerSetting'
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue"
import { formatDateTime } from "@/services/functions";

const props = defineProps<{
  gpsTrackerSetting: getGpsTrackerSettingResponse
  showDeleteButton: boolean
}>()

const emit = defineEmits<{
  (e: 'delete', id: number): void
}>()

function driverName(setting: getGpsTrackerSettingResponse): string {
  if (setting.common_driver_account) {
    return `${setting.common_driver_account.last_name} ${setting.common_driver_account.first_name}`
  }
  return ''
}
</script>

<template>
  <tbody>
    <tr>
      <td>{{ gpsTrackerSetting.id }}</td>
      <td>{{ gpsTrackerSetting.operation_office.operation_office_name }}</td>
      <td>{{ gpsTrackerSetting.trip_start_time?.slice(0, 5) }}</td>
      <td>{{ driverName(gpsTrackerSetting) }}</td>
      <td class="column-space">
        <EditLinkIcon
          :name="'GpsTrackerSettingForm'"
          :id="gpsTrackerSetting.id"
        />
      </td>
      <td>{{ formatDateTime(new Date(gpsTrackerSetting.updated_at)) }}</td>
      <td>
        <v-btn
          v-if="props.showDeleteButton"
          icon
          variant="text"
          size="small"
          color="error"
          @click="emit('delete', gpsTrackerSetting.id)"
        >
          <span class="material-symbols-outlined">delete</span>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>
